import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import BidStatusBadge from './BidStatusBadge';

const BidMobileCard = ({ bid, onEdit, onDuplicate, onConvert, onView }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    })?.format(amount);
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const parts = String(dateString)?.split('T')?.[0]?.split('-');
    if (parts?.length !== 3) return dateString;
    const [year, month, day] = parts;
    return `${month}/${day}/${year}`;
  };

  return (
    <div className="bg-card rounded-lg border border-border p-4 mb-4">
      <div className="flex items-start justify-between mb-3">
        <button
          onClick={() => onView(bid)}
          className="font-semibold text-accent hover:text-accent/80 transition-colors data-text"
        >
          {bid?.bidNumber}
        </button>
        <BidStatusBadge status={bid?.status} />
      </div>
      <div className="space-y-2 mb-4">
        <div className="flex items-center gap-2 text-sm">
          <Icon name="User" size={16} className="text-muted-foreground" />
          <span className="text-foreground">{bid?.customerName}</span>
        </div>
        <div className="flex items-center gap-2 text-sm">
          <Icon name="Briefcase" size={16} className="text-muted-foreground" />
          <span className="text-foreground">{bid?.projectName}</span>
        </div>
        <div className="flex items-center gap-2 text-sm">
          <Icon name="DollarSign" size={16} className="text-muted-foreground" />
          <span className="font-semibold text-foreground data-text">
            {formatCurrency(bid?.totalAmount)}
          </span>
        </div>
        <div className="flex items-center gap-2 text-sm">
          <Icon name="Calendar" size={16} className="text-muted-foreground" />
          <span className="text-muted-foreground">{formatDate(bid?.createdDate)}</span>
        </div>
      </div>
      <div className="flex items-center gap-2 pt-3 border-t border-border">
        <Button
          variant="outline"
          size="sm"
          onClick={() => onEdit(bid)}
          iconName="Pencil"
          iconPosition="left"
          iconSize={14}
        >
          Edit
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={() => onDuplicate(bid)}
          iconName="Copy"
          iconPosition="left"
          iconSize={14}
        >
          Duplicate
        </Button>
        {bid?.status === 'Accepted' && (
          <Button
            variant="default"
            size="sm"
            onClick={() => onConvert(bid)}
            iconName="ArrowRight"
            iconPosition="right"
            iconSize={14}
          >
            Convert
          </Button>
        )}
      </div>
    </div>
  );
};

export default BidMobileCard;